import axios, {AxiosError} from "axios";

export interface ConsignmentDefaultSettingsResponse {
    pickupPhotoRequired: boolean,
    deliveryPhotoRequired: boolean,
    deliverySignatureRequired: boolean,
}

export interface ShopifyTenantSettingsResponse {
    pickupsRequireLoadCheck: boolean,
    deliveriesRequireChecklist: boolean,
    consignmentDefaults: ConsignmentDefaultSettingsResponse,
}

const SettingsService = {

    get(
        resultFunc: (response: ShopifyTenantSettingsResponse) => void,
        errorFunc: (axiosError: AxiosError) => void
    ) {
        axios.get(`/shopify/v1/settings`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
    }

}

export default SettingsService;